import TrackShipmentResult from './trackShipmentResult';

export default TrackShipmentResult;
